/**
 * StoreKit 2 bridge (Capacitor plugin "StoreKit"). Web/PWA has no plugin →
 * every call rejects with `storekit_unavailable`; callers must never fall back
 * to web checkout inside the iOS shell.
 */
import { registerPlugin } from "@capacitor/core";
import { isIOS } from "@/lib/platform";

const plugin = registerPlugin("StoreKit");

const guard = () => {
  if (!isIOS()) {
    const err = new Error("storekit_unavailable"); err.code = "storekit_unavailable"; throw err;
  }
};

// App Store Connect · My Cruise Command (Apple ID 6816283495) · subscription group "Cruise Command Membership".
export const PRODUCT_IDS = ["com.mycruisecommand.mobile.premium.monthly", "com.mycruisecommand.mobile.premium.annual"];

export const storekit = {
  // → { products: [{ id, displayName, displayPrice, period: "month"|"year" }] } — App Store localized
  async products() { guard(); return plugin.products({ ids: PRODUCT_IDS }); },
  // → { state: "purchased"|"pending"|"cancelled", jws?: string, transactionId?: string }
  async purchase(productId, appAccountToken) { guard(); return plugin.purchase({ productId, appAccountToken }); },
  // → { transactions: [jws, ...] } current entitlements (for Restore)
  async restore() { guard(); return plugin.restore(); },
  async manageSubscriptions() { guard(); return plugin.manageSubscriptions(); },
};
